<template>
  <div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <div v-if="!oirp && !base">
      <h3 class="ang-heading mt-12 mb-2">
        Określ jakiego typu klientem jesteś
      </h3>
      <div class="row">
        <div
          class="col-md-4 d-flex align-items-stretch"
          :class="{
            selected: clientType === 0,
            dimmed: clientType !== null && clientType !== 0,
          }"
          @click.stop.prevent="setClientType(0)"
        >
          <div
            class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center"
          >
            <!---->
            <!---->
            <div class="ang-card-body d-flex flex-column">
              <h4 class="ang-card-title">Klient indywidualny</h4>
              <div class="content">
                <p class="text-muted mt-2 mb-3">
                  Osoba fizyczna (konsument) zainteresowana ofertą kredytów
                  hipotecznych, kredytów gotówkowych, ubezpieczeń lub produktów
                  inwestycyjnych.
                </p>
              </div>
              <button
                type="submit"
                class="btn ang-button ang-btn-lg _bg_color1 mt-auto"
                @click.stop.prevent="setClientType(0)"
              >
                Wybierz
              </button>
            </div>
          </div>
        </div>
        <div
          class="col-md-4 d-flex align-items-stretch"
          :class="{
            selected: clientType === 1,
            dimmed: clientType !== null && clientType !== 1,
          }"
          @click.stop.prevent="setClientType(1)"
        >
          <div
            class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center"
          >
            <!---->
            <!---->
            <div class="ang-card-body d-flex flex-column">
              <h4 class="ang-card-title">Przedsiębiorca (firma)</h4>
              <div class="content">
                <p class="text-muted mt-2 mb-3">
                  Przedsiębiorca, w tym osoba fizyczna prowadząca działalność
                  gospodarczą, zainteresowany ofertą produktów dla klientów
                  firmowych, w tym ofertą leasingu, ubezpieczenia, faktoringu
                  lub kredytu dla firm.
                </p>
              </div>
              <button
                type="submit"
                class="btn ang-button ang-btn-lg _bg_color2 mt-auto"
                @click.stop.prevent="setClientType(1)"
              >
                Wybierz
              </button>
            </div>
          </div>
        </div>
        <div
          class="col-md-4 d-flex align-items-stretch"
          :class="{
            selected: clientType === 2,
            dimmed: clientType !== null && clientType !== 2,
          }"
          @click.stop.prevent="setClientType(2)"
        >
          <div
            class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center"
          >
            <!---->
            <!---->
            <div class="ang-card-body d-flex flex-column">
              <h4 class="ang-card-title">Rolnik ryczałtowy</h4>
              <div class="content">
                <p class="text-muted mt-2 mb-3">
                  Rolnik nieposiadający numeru NIP i/lub REGON i niebędący
                  podatnikiem prowadzącym działalność gospodarczą w rozumieniu
                  przepisów ustawy z dnia 6 marca 2018 r. Prawo przedsiębiorców,
                  zainteresowany ofertą finansowania lub ubezpieczenia dla
                  rolników.
                </p>
              </div>
              <button
                type="submit"
                class="btn ang-button ang-btn-lg _bg_color3 mt-auto"
                @click.stop.prevent="setClientType(2)"
              >
                Wybierz
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3
      class="ang-heading mt-12 mb-2"
      id="clientFormHeader"
      v-if="step === 2"
      style="font-size: 1.1rem !important"
    >
      <span v-if="base"
        >Prosimy o weryfikację, aktualizację i potwierdzenie danych</span
      >
      <span v-else
        >Żebyśmy mogli się z Tobą kontaktować i świadczyć Tobie nasze usługi,
        potrzebujemy Twoich danych:</span
      >
    </h3>
    <div class="ang-card" v-show="!loading && step === 2">
      <form
        id="clientForm"
        ref="clientForm"
        method="POST"
        class="ang-card-body"
        action="/clients"
      >
        <input type="hidden" name="public_form" value="1" />
        <input
          type="hidden"
          name="solicitor"
          v-model="solicitor"
          v-if="solicitor !== null"
        />
        <input type="hidden" name="type" v-model="clientType" />
        <input type="hidden" name="base" v-model="base" v-if="base !== null" />
        <input type="hidden" name="code" v-model="code" v-if="base !== null" />
        <input
          type="hidden"
          name="lead_partner_uid"
          value="UPfVTJuS"
          v-if="oirp"
        />
        <div class="row" v-if="clientType === 1">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="nip">NIP lub REGON</label>
              <input
                type="text"
                class="ang-form-control"
                id="nip"
                name="nip"
                required
                v-model="client.nip"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="clientType === 1">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Dane osoby kontaktowej</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="first_name">Imię</label>
              <input
                type="text"
                class="ang-form-control"
                id="first_name"
                name="first_name"
                required
                v-model="client.first_name"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="last_name">Nazwisko</label>
              <input
                type="text"
                class="ang-form-control"
                id="last_name"
                name="last_name"
                required
                v-model="client.last_name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="email">Adres e-mail</label>
              <input
                type="email"
                class="ang-form-control"
                id="email"
                name="email"
                required
                v-model="client.email"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="email"
                >Powtórz adres e-mail</label
              >
              <input
                type="email"
                class="ang-form-control"
                id="email_confirmation"
                equaltoignorecase="#email"
                name="email_confirmation"
                required
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="row form-group">
              <div class="col-4 col-md-4 col-lg-3">
                <label class="ang-form-label" for="email">Kod kraju</label>
                <input
                  type="text"
                  class="ang-form-control dig"
                  value="48"
                  name="prenumerek"
                  required
                  v-model="phone_prefix"
                />
              </div>
              <div class="col-8 col-lg-9">
                <label class="ang-form-label" for="email">Numer telefonu</label>
                <input
                  type="text"
                  class="ang-form-control dig"
                  name="numerek"
                  required
                  v-model="client.phone"
                />
              </div>
            </div>
          </div>
        </div>
        <Consents
          :consents="consents"
          :clientType="clientType"
          :client="client"
        />
        <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
          <h5 class="ang-card-title">Wystąpił błąd!</h5>
          <label class="form-error error">{{ error }}</label>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <spinner v-if="sending"></spinner>
            <button
              v-else
              type="submit"
              class="btn btn-lg ang-button ang-btn-lg spinn"
            >
              Dalej
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ajax from "@/services/ajax";
import api from "@/services/api";
import spinner from "@/components/partials/misc/spinner";
import Consents from "@/components/partials/forms/registration/consents";
import $ from "jquery";
import moment from "moment";

export default {
  data() {
    return {
      consents: [],
      error: null,
      sending: false,
      expanded: false,
      loading: false,
      clientType: null,
      step: this.base && this.base.length > 0 ? 2 : 1,
      phone_prefix: "48",
    };
  },
  props: ["base", "solicitor", "client", "code", "oirp"],
  components: {
    spinner,
    Consents,
  },
  name: "angForm",
  mounted() {
    if (this.oirp) {
      this.clientType = 0;
      this.step = 2;
      this.$forceUpdate();
    }

    let self = this;

    this.$nextTick(function () {
      if (!this.oirp) {
        self.scrollToAnchor("clientFormHeader");
      }
      ajax.postValidate(
        $(self.$refs.clientForm),
        self,
        function (form, vm, data) {
          localStorage.removeItem("clientType");
          localStorage.removeItem("clientTypeExp");
          self.$emit("clientUpdated", self.client, data.verification_required);
          self.sending = false;
        },
        function (data) {
          self.error = data.message;
          self.sending = false;
          $("html,body").animate({ scrollTop: $(document).height() }, "slow");
        },
        function () {
          self.error = null;
          self.sending = true;
        }
      );
    });
    if (self.client) {
      if (self.client.phone_prefix && self.client.phone_prefix.length > 1) {
        self.phone_prefix = self.client.phone_prefix;
      }
      if (
        !this.clientType &&
        self.client.type !== null &&
        typeof self.client.type !== "undefined"
      ) {
        if (
          self.client.type === 1 &&
          (!self.client.nip || self.client.nip.length === 0)
        ) {
          self.clientType = 2;
        } else {
          self.clientType = self.client.type;
        }
      } else {
        let temp = localStorage.getItem("clientType");
        let tempExp = localStorage.getItem("clientTypeExp");
        if (temp && tempExp === moment().format("YYYY-MM-DD")) {
          self.clientType = parseInt(temp);
          self.step = 2;
        }
      }
    }
  },
  updated() {
    this.getConsents();
  },
  watch: {
    clientType() {
      let self = this;

      this.consents = [];
      this.getConsents();
      localStorage.setItem("clientType", this.clientType);
      localStorage.setItem("clientTypeExp", moment().format("YYYY-MM-DD"));
      this.$nextTick(function () {
        self.scrollToAnchor("clientFormHeader");
      });
    },
  },
  methods: {
    getConsents() {
      let self = this;
      if (
        this.clientType !== null &&
        typeof this.clientType !== "undefined" &&
        !this.loading &&
        this.consents.length === 0
      ) {
        this.loading = true;
        api.get(
          "/consents/Client?type=" + 2 ** this.clientType,
          {},
          function (data) {
            data.sort((a, b) => b.required - a.required);
            self.consents = data;
            self.$nextTick(function () {
              self.loading = false;
            });
          },
          function () {
            self.loading = false;
          }
        );
      }
    },
    setClientType(type) {
      this.clientType = type;
      this.step = 2;
      this.$forceUpdate();
    },
    scrollToAnchor(aid) {
      if (!this.oirp) {
        let aTag = $("#" + aid);
        if (
          typeof aTag !== "undefined" &&
          typeof aTag.offset() !== "undefined"
        ) {
          $("html,body").animate(
            { scrollTop: aTag.offset().top - 160 },
            "slow"
          );
        }
      }
    },
  },
};
</script>
